'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { KOALA } from 'HubStyleTokens/colors';
import ContentControlWrapper from '../../../components/ContentControlWrapper';
const ContentWrapper = styled.div.withConfig({
  displayName: "PracticalExerciseCondensedWrapper__ContentWrapper",
  componentId: "sc-14rtkiw-0"
})(["background-color:", ";padding:28px;"], KOALA);
const ButtonsWrapper = styled(ContentControlWrapper).withConfig({
  displayName: "PracticalExerciseCondensedWrapper__ButtonsWrapper",
  componentId: "sc-14rtkiw-1"
})(["display:flex;justify-content:flex-end;align-items:center;"]);

const PracticalExerciseCondensedWrapper = ({
  buttons,
  children
}) => {
  return /*#__PURE__*/_jsxs("div", {
    "data-test-id": "practical-exercise-wrapper",
    children: [/*#__PURE__*/_jsx(ContentWrapper, {
      children: children
    }), /*#__PURE__*/_jsx(ButtonsWrapper, {
      children: buttons
    })]
  });
};

PracticalExerciseCondensedWrapper.propTypes = {
  buttons: PropTypes.node,
  children: PropTypes.node
};
export default PracticalExerciseCondensedWrapper;